import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import Paper from '@material-ui/core/Paper';
import TranslateStr from '../ConfigPage/HelperLanguage/TranslateStr';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        flexGrow: 1,
        width: '100%',
        height: '100%',
    },
    des: {
      fontSize: '3vh',
      color: '#fff',
      textAlign: 'center',
    },
    avatar: {
        margin: 'auto',
        color: '#A3E4D7',
        backgroundColor: '#fff',
    },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        background: '#A3E4D7',
      },
}));

export default function ItemSwipeRight(){
    const sty = useStyles();
    return(
        <div className={sty.container}>
            <Paper className={sty.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Grid item>
                            <Avatar className={sty.avatar} alt="Add icon">
                                <AddShoppingCartIcon/>
                            </Avatar>
                        </Grid>
                        <Grid>
                            <p className={sty.des}><TranslateStr token="add"/></p>
                        </Grid>
                    </Grid>
                    <Grid item xs={9} sm container>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}